import { copy as linkCopy } from "./link";
function copy(value, context) {
  if (value == null)
    return value;
  return value.map(copyNavigationLinksPanelItem);
  function copyNavigationLinksPanelItem(item) {
    switch (item.type) {
      case "button":
      case "dropdown": {
        const { color, link } = item.payload;
        return {
          ...item,
          payload: {
            ...item.payload,
            link: link != null ? linkCopy(link, context) : void 0,
            color: color != null ? color.map((override) => ({
              ...override,
              value: {
                ...override.value,
                swatchId: context.replacementContext.swatchIds.get(override.value.swatchId) ?? override.value.swatchId
              }
            })) : void 0
          }
        };
      }
      default:
        return item;
    }
  }
}
export {
  copy
};
//# sourceMappingURL=navigation-links.js.map